module.exports = __webpack_public_path__ + "img/identifai-1.c2f06098.jpeg";